var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.Calciatore
    ? _c("div", { staticClass: "calciatore-su-tavolo-container" }, [
        _c("div", { staticClass: "calciatore-su-tavolo-img" }, [
          _c("div", { staticClass: "imgCalciatore without-ms" }, [
            _c("div", { staticClass: "imgContainer imgContainer-ruolo_" }, [
              _vm.Config.AVATAR_OR_FLAG == "avatar"
                ? _c("div", {
                    key: _vm.Calciatore.nid,
                    staticClass: "img",
                    style: {
                      backgroundImage:
                        "url(" +
                        (_vm.Calciatore.imgCalciatore
                          ? _vm.Calciatore.imgCalciatore
                          : _vm.Config.PUBLIC_DIR +
                            "/schede_calciatori/avatar/default/avatar_club_" +
                            _vm.Calciatore.ID_Club +
                            ".png") +
                        ")",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.Config.AVATAR_OR_FLAG == "flag"
                ? _c("div", {
                    key: _vm.Calciatore.nid,
                    staticClass: "img flag",
                    style: {
                      backgroundImage:
                        "url(" +
                        (_vm.Config.PUBLIC_DIR +
                          "/clubs/flags/flag_" +
                          _vm.Calciatore.ID_Club +
                          ".png") +
                        ")",
                    },
                  })
                : _vm._e(),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "calciatore-su-tavolo-nomeCalciatore" }, [
          _c("span", { class: ["Ruolo", "Ruolo_" + _vm.Calciatore.ID_Ruolo] }, [
            _vm._v(_vm._s(_vm.ruolo(_vm.Calciatore.ID_Ruolo))),
          ]),
          _vm._v("\n    " + _vm._s(_vm.Calciatore.calciatore) + "\n  "),
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "calciatore-su-tavolo-nomeClub ellipsis" }, [
          _vm._v(_vm._s(_vm.Calciatore.nomeClub)),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }